<template>
<div>
        <loader v-if="loading"/>
        <div v-show="!loading">
            <div id="paymentAlert" class="alert alert-danger" role="warning">
                <strong>Payment was not approved: </strong>{{paymentResponse.ResultMessage}}
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Transaction ID</label>
                <div class="col-md-8">
                        <span class="textValue">{{paymentResponse.TransactionId}}</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Transaction Date</label>
                <div class="col-md-8">
                        <span class="textValue">{{paymentResponse.TransactionDate}}</span>
                </div>
            </div>
            <div class="form-group">
                <label class="col-md-3 control-label">Amount</label>
                <div class="col-md-8">
                        <span class="textValue">{{paymentResponse.Amount}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-2">
                    <button name="button2" class="btn btn-primary btn-block" type="submit" v-on:click="goPayment" style="width:160px;">Return to Payment</button>
                </div>
            </div>
        </div>
        <div v-show="isDebug">
            <div>
                <h3 class="text-danger">****** Debug ******</h3>
            </div>
            <div>
                <h4>paymentResponse: </h4>
                <pre>{{ $route.query }}</pre>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import loader from '../components/Loader.vue'
export default {
    components: {
        loader
    },
    mounted () {
        loggingService.log(this.isDebug, 'FileSearchPaymentFail', 'mounted, result: ' + this.$route.query.ssl_result_message)
        this.paymentResponse.ResultMessage = this.$route.query.ssl_result_message
        this.paymentResponse.TransactionId = this.$route.query.ssl_txn_id
        this.paymentResponse.TransactionDate = this.$route.query.ssl_txn_time
        this.paymentResponse.Amount = this.$route.query.ssl_amount

        var productDescription = this.$route.query.ProductDescription
        loggingService.log(this.isDebug, 'FileSearchPaymentFail', 'productDescription ' + productDescription)
        var start = productDescription.indexOf('FS: ') + 4
        var end = productDescription.length
        this.fileSearchId = productDescription.substr(start, end)
        loggingService.log(this.isDebug, 'FileSearchPaymentFail', 'mounted, fileSearchID: ' + this.fileSearchId)
        this.loading = false
    },
    data: function () {
        return {
            loading: true,
            isDebug: false,
            paymentResponse: {}
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        goPayment () {
            loggingService.log(this.isDebug, 'FileSearchPaymentFail', 'Go Payment')
            this.$router.push('/FileSearchPayment/' + this.fileSearchId)
        }
    }
}
</script>



// WEBPACK FOOTER //
// FileSearchPaymentFail.vue?32826268